import { createPaginatedSlice } from "../../../helpers/reduxHelper";

const paginatedTextures = createPaginatedSlice('paginatedTextures');

export const paginatedTexturesActions = paginatedTextures.actions
export const paginatedTexturesSelector = state => state.paginatedTextures;
export const paginatedTexturesReducer = paginatedTextures.reducer;
export default paginatedTexturesReducer

export const paginatedTexturesSelectors = paginatedTextures.LF.selectors